<template>
    <CContainer>
        <CTabs variant="tabs" :active-tab="0">
            <CTab>
                <template #title><CIcon name="cil-task"/> <span class="ml-1">Aprobaciones</span></template>
                <PendingOrders class="p-3"/>
            </CTab>
            <CTab>
                <template #title><CIcon name="cil-truck"/><span class="ml-1">Acuse Recibo</span></template>
                <AcknowledgeReceipt class="p-3"/>
            </CTab>
        </CTabs>
    </CContainer>
</template>

<script>
  import PendingOrders from './PendingOrders'
  import AcknowledgeReceipt from './AcknowledgeReceipt'
  
  export default {
    name: 'OrderProcesses',
    components:{
      PendingOrders,
      AcknowledgeReceipt
    }
  }
</script>